import getUpdatedMatrix from "reducers/lockingSystemReducer/utils/getUpdatedMatrix"
import getUpdatedComponentsByUuid from "reducers/lockingSystemReducer/utils/getUpdatedComponentsByUuid"
import getLockingSystemPricePortions, {
	getLockingSystemMsrpPricePortions,
} from "reducers/lockingSystemReducer/utils/getLockingSystemPricePortions"

import {
	DispatchLockingSystemReducer,
	LockingSystemReducerState,
} from "reducers/lockingSystemReducer"

type DeleteKeyComponentsPayload = Pick<
	LockingSystemReducerState,
	| "keyComponentsUuids"
	| "componentsByUuid"
	| "matrix"
	| "matrixType"

	// Price
	| "singleNetPriceCents"
	| "singleGrossPriceCents"
	| "totalNetPriceCents"
	| "totalGrossPriceCents"

	// Msrp price
	| "singleNetMsrpPriceCents"
	| "singleGrossMsrpPriceCents"
	| "totalNetMsrpPriceCents"
	| "totalGrossMsrpPriceCents"
>

export const deleteKeyComponents = (
	dispatch: DispatchLockingSystemReducer,
	reducerState: LockingSystemReducerState,
	uuids: string[],
) => {
	const { lockingComponentsUuids, quantity } = reducerState

	const removedKeyComponentColumnIndices = reducerState.keyComponentsUuids.reduce(
		(removedKeyComponentColumnIndices, uuid, keyComponentColumnIndex) => {
			if (uuids.includes(uuid)) {
				return [...removedKeyComponentColumnIndices, keyComponentColumnIndex]
			}

			return removedKeyComponentColumnIndices
		},
		[] as number[],
	)
	const keyComponentsUuids = reducerState.keyComponentsUuids.filter(
		(uuid) => !uuids.includes(uuid),
	)

	// Remove matrix rows of removed components
	const updatedMatrix = reducerState.matrix.map((columns) => {
		const updatedRow = columns.filter(
			(_, columnIndex) => !removedKeyComponentColumnIndices.includes(columnIndex),
		)

		return updatedRow
	})

	const { matrix, matrixType } = getUpdatedMatrix(
		lockingComponentsUuids,
		keyComponentsUuids,
		updatedMatrix,
	)

	const componentsByUuid = getUpdatedComponentsByUuid(
		[...lockingComponentsUuids, ...keyComponentsUuids],
		reducerState.componentsByUuid,
	)

	const { singleNetPriceCents, singleGrossPriceCents, totalNetPriceCents, totalGrossPriceCents } =
		getLockingSystemPricePortions(componentsByUuid, quantity)

	const {
		singleNetMsrpPriceCents,
		singleGrossMsrpPriceCents,
		totalNetMsrpPriceCents,
		totalGrossMsrpPriceCents,
	} = getLockingSystemMsrpPricePortions(componentsByUuid, quantity)

	const payload: DeleteKeyComponentsPayload = {
		keyComponentsUuids,
		componentsByUuid,
		matrix,
		matrixType,

		// Price
		singleNetPriceCents,
		singleGrossPriceCents,
		totalNetPriceCents,
		totalGrossPriceCents,

		// Msrp price
		singleNetMsrpPriceCents,
		singleGrossMsrpPriceCents,
		totalNetMsrpPriceCents,
		totalGrossMsrpPriceCents,
	}

	dispatch({
		type: "DELETE_KEY_COMPONENTS",
		payload,
	})
}
